<template>
  <div class="store stargrid">
     <img class="main-logo" src="../assets/hatching.mp4" />
    <h1>Mint an Astro-Egg:</h1>
    <template>
      <div class="store-container">
        <ul>
          <li :key="index" v-for="(item, index) in dev_store.result">
            <button  @click="buyEgg(item.order_id)">Buy Egg</button>
            <img :src="item.sell.data.properties.image_url" />
            <h3>
              {{ item.sell.data.properties.name }}<span>Stored in {{ item.status }}</span>
            </h3>
            <p>Attributes: 
              <template v-if="item.metadata">{{ Object.keys(filterAttr(item.metadata,['description', 'external_url', 'image', 'name'])).length - 1 }}</template>
              <template v-else>n/a</template>
            </p>
          </li>
        </ul>
      </div>
    </template>
    <template v-if="selectedIndex != null && dev_store.result[selectedIndex]">
      <!--<ModalItem :astrobro="dev_store.result[selectedIndex]" @closed="modalClose"/>-->
    </template>
  </div>
</template>

<script>
//import ModalItem from "@/components/ModalItem.vue";

export default {
  name: "Store",
  components: {
   //ModalItem
  },
  props: {
    msg: String,
  },
  data() {
    return {
      selectedIndex: null,
      client: {},
      wallet: "",
      balance: {},
      store: {},
      marketplace: {},
    };
  },
  mounted() {
    // initialise an Immutable X Client to interact with apis more easily
    this.$imxClient
      .build({ publicApiUrl: process.env.VUE_APP_MAINNET_ENV_URL, registrationContractAddress:process.env.VUE_APP_MAINNET_REGISTRATION_ADDRESS })
      .then((response) => {
        this.client = response; 
        this.linkRegister()
        });
    
  },
  methods: {
    buyEgg(id) {
      id = id.toString()
      this.link.buy({orderId: id});
    },
    filterAttr(attr, whitelist) {
      return Object.keys(attr).filter(key => !whitelist.includes(key)).reduce((obj, key) => {
        obj[key] = attr[key];
        return obj;
      }, {});
    },
    modalClose(value) {
      if (value) {
        this.selectedIndex = null
      }
    },
    linkRegister() {
      // user signup to imx and get
      /*const { address } = await link.setup({});
      localStorage.setItem('address', address);*/
      /*if (localStorage.getItem('imxaddress')) {
        this.wallet = localStorage.getItem('imxaddress');
        this.client
          .getBalance({ user: this.wallet, tokenAddress: "eth" })
          .then((response) => (this.balance = response));
        this.client.getOrders({ status:'active', sell_token_address: this.astroContract })
          .then((response) => (this.store = response));
        this.client
          .getOrders({ status: this.$linkTypes.ImmutableOrderStatus.active })
          .then((response) => (this.marketplace = response));
      } else {*/
      const linked = this.link.setup(process.env.VUE_APP_MAINNET_LINK_URL);
      linked.then((res) => {
        localStorage.setItem('imxaddress', res.address)
        this.wallet = res.address;
        this.client
          .getBalance({ user: this.wallet, tokenAddress: "eth" })
          .then((response) => (this.balance = response));
        this.client.getOrders({ status:'active', sell_token_address: this.astroContract })
          .then((response) => (this.store = response));
        this.client
          .getOrders({ status: this.$linkTypes.ImmutableOrderStatus.active })
          .then((response) => (this.marketplace = response));
      });
     // }
    },
  },
  computed: {
    astroContract() {
      return process.env.VUE_APP_TOKEN_ADDRESS;
    },
    link() {
      return new this.$link(process.env.VUE_APP_MAINNET_LINK_URL);
    },
    alchemy() {
      return process.env.VUE_APP_ALCHEMY_API_KEY;
    },
    dev_balance() {
      if ("balance" in this.balance) {
        return this.balance;
      }
      return {
        symbol: "ETH",
        balance: { _hex: "0x0d0b8d0508de0000", _isBigNumber: true },
        preparing_withdrawal: { _hex: "0x00", _isBigNumber: true },
        withdrawable: { _hex: "0x00", _isBigNumber: true },
      };
    },
    dev_store() {
      if ("cursor" in this.store) {
        return this.store;
      }
      return {
        result: [
          {
            token_address: "0x4f248889d50cc4667c5994ff519a550de1563be2",
            token_id: "42",
            id: "0x48cd98bc0e9361581b52a48e2d7f0adbea1b7c16379b1cb63d1b8041f43f7e63",
            user: "0x208cf20733bcd78a614184ecbcb0fda24b4fc469",
            status: "imx",
            uri: null,
            name: "Astrobro #42",
            description:
              "Astrobros - Non-fungible, randomly built, animated collectibles, blasting off into dimensions unknown! Their quest? To become Mr.Omniverse, crush the Skeldar and establish a muscle beach on every stretch of sand from here to the Universal Core! \nEach Astrobro is a unique one-of-a-kind muscle-head generated from hundreds of assets of varying scarcity. To pick up your 'bro and find out more, visit https://astrobros-nft.com",
            image_url: "https://api.astrobros-nft.com/bros/imgs/full/42.gif",
            metadata: {
              bg: "Moon",
              back: "Jetwing",
              body: "Pose #2",
              hair: "Quiff",
              head: "Helmet #7",
              name: "Astrobro #42",
              image: "https://api.astrobros-nft.com/bros/imgs/full/42.gif",
              "texture-2": "Pattern #7",
              "body-lower": "Circulatory Gear",
              description:
                "Astrobros - Non-fungible, randomly built, animated collectibles, blasting off into dimensions unknown! Their quest? To become Mr.Omniverse, crush the Skeldar and establish a muscle beach on every stretch of sand from here to the Universal Core! \nEach Astrobro is a unique one-of-a-kind muscle-head generated from hundreds of assets of varying scarcity. To pick up your 'bro and find out more, visit https://astrobros-nft.com",
              orientation: "Right",
              external_url: "https://astrobros-nft.com",
            },
            collection: { name: "Astrobros", icon_url: "" },
            orders: {},
            created_at: "2021-09-15T16:44:22.161101Z",
            updated_at: "2021-09-18T22:15:57.978479Z",
          },
        ],
        cursor:
          "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",
        remaining: 0,
      };
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
h3 {
  margin: 40px 0 0;
}
div.store-container>ul {
  list-style-type: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 24px 16px;
}
div.store-container>ul>li {
 cursor: pointer;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    position: relative;
    overflow: hidden;
    width: 100%;
    border: solid 2px #20a15a;
    border-radius: 5px;
    background: #141422;
    color: #99f87b;
    padding: 10px;
    box-sizing: border-box;
    transition: box-shadow 0.1s;
}
div.store-container>ul>li:hover {
    box-shadow: #ffffff 0px 8px 7px -10px, #0aff52 0px 10px 25px -12px, #005eaa 0px 10px 40px -15px;
}
.store-container h1 {
      padding: 10px;
    margin: 0;
    background: #8637de;
    color: #ffffff;
}
.store-container h3 {
    padding: 10px;
    margin: 0;
    background: #a12c20;
    color: #ffffff;
    font-weight: bold;
}
div.store {
    width: 80%;
    margin: 60px auto;
    padding: 20px;
    box-sizing: border-box;
    border: solid 2px #5e2781;
}
div.store-container h3>span {
      font-size: 0.7em;
    margin-left: 10px;
    color: #ffffff;
    background: #6c6c6c;
    padding: 2px 10px;
    border-radius: 15px;
}
a {
  color: #42b983;
}
</style>
